(function () {
  angular.module("akitabox.core.auth.register", [
    "ngMaterial",
    "ui.router",
    "akitabox.core.constants",
    "akitabox.core.router",
    "akitabox.core.services.auth",
  ]);
})();
